import { Organization } from './';

export interface UserApprove {
  email: string;
  firstName: string;
  lastName: string;
  userId: number;
  organizationId: number;
  registerDate: Date;

  organization: Organization;

  isBeingDismissed: boolean;
  organizationName: string;

  userType: number;
}
